import React, { useRef, useState } from "react"
import { Button, Group, LoadingOverlay, Modal, ModalProps, Stack, Text, TextInput } from "@mantine/core"
import { useCreatePricingVersion, usePricingVersionRules } from "../../../hooks/global-job-matching"
import { PricingVersion } from "../GlobalJobMatchingVersioning/types/versions"
import { PricingRule } from "../GlobalJobMatchingVersioning/types/rules"

type CreateNewVersionModalProps = {
  cloneVersion: PricingVersion | undefined
} & ModalProps

export const CreateNewVersionModal = ({ opened, onClose, cloneVersion }: CreateNewVersionModalProps) => {
  const [newVersionName, setNewVersionName] = useState('')
  const { data: rules } = usePricingVersionRules(cloneVersion?.id)
  const { mutate: createNewVersion, isLoading: isCreating } = useCreatePricingVersion()
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleCreate = () => {
    createNewVersion({ name: newVersionName, version: cloneVersion ?? null, rules: rules as PricingRule ?? null })
  }

  return (
    <Modal size='xl' title={cloneVersion ? `Clone Version ${cloneVersion?.name}` : 'Create New Version'} opened={opened} onClose={onClose} onTransitionEnd={handleFocus}>
      <Stack>
        <LoadingOverlay visible={isCreating} />
        <Text>What would you like to name the new version?</Text>
        <TextInput
          ref={inputRef}
          placeholder='New version name'
          size='lg'
          value={newVersionName}
          onChange={e => setNewVersionName(e.currentTarget.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              handleCreate()
            }
          }}
        />
        <Group justify='flex-end' mt='xl'>
          <Button size='lg' variant='outline' onClick={onClose}>Cancel</Button>
          <Button disabled={!newVersionName.length} size='lg' onClick={handleCreate}>{cloneVersion ? 'Clone' : 'Create'}</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
